//There is a problem if we have a locale like en_BE or en_UA.  The problem is moment doesn't have a locale for belgium or ukraine english.
// So we use the preferred language for the country to format dates.  Don't use this if you need to display text with the date the text will be in the wrong language.
const preferredLocale = {
    HK: 'zh-hk',
    TW: "zh-tw",
    US: "en-us",
    CA: "en-ca",
    CO: "es",
    AR: "es",
    MX: "es",
    CL: "es",
    PE: "es",
    AT: "de",
    BE: "nl",
    CH: "fr-ch",
    DE: "de",
    ES: "es",
    FR: "fr",
    GB: "en-gb",
    IT: "it",
    NL: "nl",
    PT: "pt",
    CZ: "cs",
    HU: "hu",
    PL: "pl",
    RO: "ro",
    RU: "ru",
    SK: "sk",
    TR: "tr",
    UA: "uk",
    DK: "da",
    FI: "sv",
    IE: "en-ie",
    IS: "is",
    NO: "nn",
    SE: "sv",
    ZA: "en",
    IL: "he",
    BN: "en",
    ID: "id",
    MY: "ms",
    PH: "en",
    SG: "en-SG",
    TH: "th",
    VN: "vi",
    AU: "en-au",
    NZ: "en-nz",
    PF: "fr",
    NC: "fr",
    JP: "ja"
};

// Full locales that moment supports
const fullMomentLocales = {
    es_US: 'es-us',
    fr_CA: 'fr-ca',
    fr_CH: 'fr-ch',
    en_NZ: 'en-nz',
    en_AU: 'en-au',
    en_IE: 'en-ie',
    en_SG: 'en-SG',
    en_GB: 'en-gb',
    en_CA: 'en-ca',
    zh_CN: 'zh-cn',
    zh_HK: 'zh-hk',
    zh_TW: 'zh-tw',
    zh_US: 'zh-tw',
    za_US: 'zh-cn'
};

/**
 * Returns the valid moment locale using the nuskin locale passed in
 * @param locale      the Nu Skin locale en_US fr_FR ...
 * @returns {string}  moment locale en-ca fr-ch fr ...
 */
const getMomentLocale = (locale) => {
    if (fullMomentLocales.hasOwnProperty(locale)) {
        locale = fullMomentLocales[locale]
    } else if (locale.length > 2) {
        // Get the country from the locale and get the preferred locale for that country
        locale = preferredLocale[locale.split("_")[1]]
            ? preferredLocale[locale.split("_")[1]]
            : locale
    }
    return locale
}

export default getMomentLocale;
